import { useState } from 'react'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { Blasenwahl, type Blasensatz } from './Blasenwahl'

/**
 * Die **Voreinstellung** für die Farben der Sprechblasen — hier und nicht im Chat.
 *
 * Anders als bei der Linie auf der Karte: dort stellt man ein, was man
 * gleichzeitig ansieht. Ein Farbfeld über dem Chat läge dagegen mitten im
 * Gespräch und wäre jeden Tag im Weg, für eine Einstellung, die man einmal
 * trifft. Deshalb steht sie hier — **mit zwei Beispielblasen**, damit man das
 * Ergebnis trotzdem sofort sieht.
 *
 * **Seit #49 ist sie die Voreinstellung und nicht mehr die Farbe selbst.** Sie
 * wird beim Anlegen einer Reise kopiert; die Farbe steht danach an der Reise.
 * Wer eine bestehende Reise nachziehen will, findet dort den Knopf
 * *Voreinstellung übernehmen*.
 */
export function ChatfarbenCard() {
  const settings = useSettings()
  const save = useSaveSettings()
  const [gemeldet, setGemeldet] = useState(false)

  const daten = settings.data
  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling) return null

  const werte = daten.settings

  return (
    <div className="card card--seite">
      <h2 className="card__titel">Farbe der Sprechblasen</h2>
      <Blasenwahl
        lead="Die Voreinstellung für neue Reisen — eine bestehende Reise ändert sie nicht mehr. Ihre Farbe steht auf ihrer Infoseite unter „Aussehen“."
        werte={{
          chat_own_color: werte.chat_own_color ?? '',
          chat_other_color: werte.chat_other_color ?? '',
        }}
        laeuft={save.isPending}
        fehler={
          save.isError
            ? save.error instanceof Error
              ? save.error.message
              : 'Das hat nicht geklappt.'
            : null
        }
        gemeldet={gemeldet}
        onSpeichern={async (satz: Blasensatz) => {
          setGemeldet(false)
          await save.mutateAsync(satz)
          setGemeldet(true)
        }}
      />
    </div>
  )
}
